module.exports = __webpack_public_path__ + "img/pr-12.8a7083c0.png";